import { render } from "./CheckSwitch.vue?vue&type=template&id=2acf7d22&scoped=true"
import script from "./CheckSwitch.vue?vue&type=script&lang=js"
export * from "./CheckSwitch.vue?vue&type=script&lang=js"

import "./CheckSwitch.vue?vue&type=style&index=0&id=2acf7d22&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acf7d22"]])

export default __exports__